import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Artists from "@/pages/Artists";
import ArtistProfile from "@/pages/ArtistProfile";
import Services from "@/pages/Services";
import Enquire from "@/pages/Enquire";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin, { ForgotPassword, ResetPassword } from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import AdminArtists from "@/admin/AdminArtists";
import AdminServices from "@/admin/AdminServices";
import AdminEnquiries from "@/admin/AdminEnquiries";
import AdminReviews from "@/admin/AdminReviews";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/makeup-artists" element={<Artists />} />
            <Route path="/makeup-artists/lucknow" element={<Artists initialCity="Lucknow" />} />
            <Route path="/makeup-artists/:slug" element={<ArtistProfile />} />
            <Route path="/services" element={<Services />} />
            <Route path="/enquire" element={<Enquire />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="artists" element={<AdminArtists />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="enquiries" element={<AdminEnquiries />} />
            <Route path="reviews" element={<AdminReviews />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
